import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: '¿Y si solo tengo 30 minutos?',
    answer: 'Usas 25/5 y cierras una versión más pequeña. La meta no es hacer más. La meta es cerrar. Un micro-cierre es mejor que nada abierto.'
  }, {
    question: '¿Y si me interrumpen cada 5 minutos?',
    answer: 'Por eso existe el protocolo de retorno. No necesitas silencio perfecto. Necesitas un sistema para volver al bloque sin perder el hilo. El método está diseñado para oficinas reales, no para retiros de montaña.'
  }, {
    question: '¿Sirve si tengo demasiadas reuniones?',
    answer: 'Sí, porque el método te obliga a proteger un bloque y a convertir el resto en decisiones conscientes (no ruido). Incluso con 4 reuniones al día, puedes cerrar 1 tarea importante.'
  }, {
    question: '¿Para quién es este sistema?',
    answer: 'Para ti si: vives con inbox + reuniones + WhatsApp/Slack, te interrumpen todo el día, te cuesta priorizar y terminas reaccionando, sientes estrés por pendientes que no se cierran, quieres un sistema simple, visual y repetible.'
  }, {
    question: '¿Para quién NO es?',
    answer: 'No es para ti si: buscas motivación o frases bonitas, quieres teoría larga sin plantillas, no estás dispuesto a usar timer + checklist. Este es un sistema operativo, no inspiracional.'
  }, {
    question: '¿Cuánto tiempo toma ver resultados?',
    answer: 'El sistema está diseñado para implementación inmediata. Muchos usuarios reportan una sensación de alivio y control desde el primer día. Los cambios profundos en hábitos suelen consolidarse en 21 días.'
  }, {
    question: '¿En qué formato recibiré el contenido?',
    answer: 'Recibirás acceso inmediato a la versión digital en PDF de alta calidad, optimizada para leer en tablet, móvil o computadora. También incluye las plantillas en formato editable para que las adaptes a tu flujo.'
  }];
  return <section className="py-24 bg-dark-800" data-id="element-184">
      <div className="max-w-3xl mx-auto px-4" data-id="element-185">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-186">
          Preguntas{' '}
          <span className="text-gold-500 font-serif italic" data-id="element-187">Frecuentes</span>
        </h2>

        <div className="space-y-4" data-id="element-188">
          {faqs.map((faq, index) => <div key={index} className={`border rounded-xl overflow-hidden transition-colors duration-300 ${openIndex === index ? 'border-gold-500/50 bg-white/5' : 'border-white/10 bg-transparent hover:border-white/20'}`} data-id="element-189">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-190">
                <span className={`font-medium text-lg ${openIndex === index ? 'text-gold-500' : 'text-white'}`} data-id="element-191">
                  {faq.question}
                </span>
                {openIndex === index ? <ChevronUp className="w-5 h-5 text-gold-500 flex-shrink-0 ml-4" data-id="element-192" /> : <ChevronDown className="w-5 h-5 text-gray-400 flex-shrink-0 ml-4" data-id="element-193" />}
              </button>

              <AnimatePresence data-id="element-194">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-195">
                    <div className="px-6 pb-6 text-gray-300 leading-relaxed border-t border-white/5 pt-4" data-id="element-196">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}